import { TextField } from "@material-ui/core";
import React from "react";

export default function CouponsLimitSelector({
  value = "",
  onChange,
  label = "Cantidad máxima de cupones",
  error = null,
  required = false,
}) {
  return (
    <TextField
      label={label}
      type="number"
      variant="outlined"
      fullWidth
      required={required}
      error={!!error}
      value={value ?? ""}
      onChange={(event) => {
        const newValue = event.target.value;
        if (newValue === "") {
          onChange("");
        } else if (
          /^\d+$/.test(newValue) &&
          Number.isSafeInteger(Number(newValue)) &&
          Number(newValue) > 0
        ) {
          onChange(Number(newValue));
        }
      }}
      inputProps={{ min: 1, step: 1 }}
      helperText={
        error || "Entero positivo. Dejar vacío para no limitar la cantidad."
      }
    />
  );
}
